export enum ButtonIconColor {
	BASIC = 'basic',
	PRIMARY = 'primary',
  SECONDARY = 'secondary',
}
